<template>
  <div class="user-guide-wraper">
    <!-- 引导弹窗 -->
    <div v-for="items in data" :key="items.id">
      <div v-if="bootSteps === items.id  && !hideNowStep" :class="items.class">
        <div :class="['user-guide-mask', 'user-guide-mask-' + items.type]" v-if="items.needMask">
          <template v-if="items.type === 'default'">
            <div
              class="user-guide-top"
              :style="{
                height: (items.highlightArea.top + isMsgTop) + 'px'
              }"></div>
            <div
              class="user-guide-left"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                width: items.highlightArea.left + 'px',
                height: items.highlightArea.height + 'px'
              }"></div>
            <div
              class="user-guide-right"
              :style="{
                top: items.highlightArea.top + isMsgTop + 'px',
                left: items.highlightArea.left + items.highlightArea.width + 'px',
                height: items.highlightArea.height + 'px'
              }"></div>
            <div
              class="user-guide-bottom"
              :style="{
                top: items.highlightArea.top + isMsgTop + items.highlightArea.height + 'px'
              }"></div>
          </template>
        </div>
        <div
          class="user-guide-content"
          :style="items.type === 'modal' ? {
            top: '50%',
            left: (clientWidth + items.modalArea.width + items.guideWidth) / 2 + 'px',
          } : {
            top: items.guideArea.top + (items.type === 'modal' ? 0 : isMsgTop) + 'px',
            left: items.guideArea.left + 'px',
          }">
          <div class="user-guide-main flex justify-between">
            <div v-if="items.content">{{ items.content }}</div>
            <i class="el-icon-close size16 gj-ml8 gj-pointer" @click="setUserGuideState" style="color: rgba(255, 255, 255, 0.4)"></i>
          </div>
          <div class="flex justify-between align-center gj-mt12">
            <div>{{bootSteps}}/{{data.length}}</div>
            <div v-if="items.btnList.length" class="btnList">
              <div v-if="items.btnList.includes('continue')" class="gj-pointer knowBtn" @click="continueAdd">继续添加</div>
              <div v-if="items.btnList.includes('next')" class="gj-pointer btn-next" @click="nextTask">下一步</div>
              <div v-if="items.btnList.includes('video')" class="gj-pointer">
                <gj-link style="color:#fff;" type="text" :href="getVideoUrl(taskItem.videoUrlCode)" target="_blank">参考教程 </gj-link><i class="el-icon-arrow-right"></i>
              </div>
              <div v-if="items.btnList.includes('know')" @click="nextTask" class="gj-pointer knowBtn">我知道了</div>
              <div v-if="items.btnList.includes('complete')" @click="completeTask" class="gj-pointer completeBtn">完成任务</div>
            </div>
          </div>
          <div class="user-guide-point" :class="items.pointClass ? 'user-guide-point-vertical' : ''" :style="{ width: items.guideWidth + 'px', left: `-${items.guideWidth}px` }">
            <div class="user-guider-line" :class="items.lineClass ? 'user-guider-line-vertical' : ''"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SET_USER_GUIDE_STATE, SET_USER_GUIDE_MENU_PATH} from "@/store/mutation-types";
import appUserGuideSucc from "@/views/components/user-guide-succ-modal/user-guide-succ-modal"
import {mapGetters} from "vuex";
import NoviceGuide from '@/views/modules/home/novice-guide/novice-guide'
import {userGuideMixin} from "@/minxins";

export default {
  name: "new-user-guide",
  props: {
    guideRef: {
      value: null
    },
    hideNowStep: false
  },
  mixins: [userGuideMixin],
  data() {
    return {
      bootSteps: 0,
      startStep: 'storeAuthorize',
      data: [],
      taskName: '',
      taskList: {},
      isMsgTop: 0,
      clientWidth: 0,
      taskItem: {},
      routerTaskItem: {},
    }
  },
  computed: {
    ...mapGetters({
      isMsgsGlobal: 'isMsgsGlobal',
      userGuideState: 'userGuideState',
    })
  },
  watch: {
    isMsgsGlobal: {
      handler(val) {
        console.log('isMsgsGlobal=', this.isMsgsGlobal)
        this.isMsgTop = val ? 34 : 0;
      },
      immediate: true
    },
    userGuideState: {
      handler(newState, oldState) {
        if(!newState && oldState) this.cancel();
      }
    }
  },
  created() {
    this.clientWidth = document.body.clientWidth
    this.taskItem = this.userGuideTaskItem
    this.routerTaskItem = this.userGuideTaskItem
    this.initData()
  },
  methods: {
    initData(){
      const isNavHorizontal = localStorage.getItem('NAV_STATE') !== 'vertical'
      const subtractHeight =  isNavHorizontal ? 0 : 40; 
      const addWidth =  isNavHorizontal ? 0 : 60; 
      this.subtractHeight = subtractHeight;
      this.addWidth = addWidth;
      this.taskList = {
        storeAuthorize: [
          {
            id: 1,
            class: "user-guide-one",
            type: 'default',
            needMask: true,
            highlightArea: {
              width: 65,
              height: 34,
              top: 147- subtractHeight,
              left: 30 + addWidth,
            },
            guideArea: {
              top: 125 - subtractHeight,
              left: 168  + addWidth,
            },
            guideWidth: 80,
            pointClass: '',
            lineClass: '',
            content: "您可以通过【添加】按钮逐个添加\n如果没有在系统维护仓库资料，则无法在系统完成采购订单、调拨单流程哦~",
            btnList: ['video'],
          },
          {
            id: 2,
            class: "user-guide-two",
            type: 'default',
            needMask: true,
            highlightArea: {
              width: this.clientWidth - 60 - addWidth,
              height: 110,
              top: 190 - subtractHeight,
              left: 30 + addWidth,
            },
            guideArea: {
              top: 400  - subtractHeight,
              left: 1000,
            },
            guideWidth: '-50%',
            modalArea: {
              width: 680
            },
            pointClass: 'user-guider-line-vertical',
            lineClass: 'user-guider-line-vertical',
            guideRef: null,
            content: "您已添加了仓库资料，可以留在此页面继续添加，也可按照教程继续完成其他任务~",
            btnList: ['continue','next'],
          },
        ],
      }
      this.bootSteps = 1;
      this.data = this.taskList[this.startStep];
      this.taskName = this.startStep;
    },
    prevStep() {
      this.bootSteps--;
    },
    nextStep() {
      this.bootSteps++;
      let activeItem = this.data.find(item => item.id === this.bootSteps);
      if(activeItem && activeItem.type === 'menu') {
        this.$store.commit(SET_USER_GUIDE_MENU_PATH, activeItem.path);
      }
    },
    async nextTask() { // 下个任务
      // if(this.taskName === 'storeAuthorize') {
        const taskItem = this.taskItem
        const {finishTaskList, nextTask}  = await this.getNextTask(taskItem?.taskTypeCode, taskItem?.taskChildCode)
        if (finishTaskList && this.routerTaskItem.taskStatus != 'COMPLETED'){
          this.completeTask();
        }else if (nextTask){
            if (this.isWaitTurnOn(nextTask.taskStatus)){// 任务未开启，需要 打开新手指引弹窗
            this.$message.warning( `${nextTask.taskChildName}任务未开启，请先开启任务~`)
            this.openNoviceGuide();
          }else {//下一步不属于当前组件，跳转新页面
            this.jumpToGuidePage(nextTask, () => {
              this.bootSteps = 0;
              this.data = [];
              this.taskName = '';
              this.$emit('finishGuide');
              this.$emit('closeModal');
            })
          }
        }else {
            this.cancel()
        }
    },
    openNoviceGuide() {
      this.bootSteps = 0
      this.startStep = ''
      this.data = [];
      this.$gjCreate(NoviceGuide)
    },
    completeTask() {
      this.bootSteps = 0;
      this.data = [];
      this.$emit('closeModal');
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
      this.$gjCreate(appUserGuideSucc,{
        global: true,
        props: {
          id: this.taskItem?.taskTypeCode
        }
      })
    },
    continueAdd(){
      this.bootSteps = 2;
      this.data = [];
      this.taskName = '';
    },
    setUserGuideState() {
      this.$store.commit(SET_USER_GUIDE_STATE, false);
    },
    cancel() {
      //关闭引导
      this.bootSteps = 0;
      this.$emit('closeModal')
      this.$store.commit(SET_USER_GUIDE_MENU_PATH, '');
    },
  }
}
</script>
<style lang="scss" scoped>
.user-guide-mask {
  .user-guide-top, .user-guide-left, .user-guide-right, .user-guide-bottom {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.4);
  }
}
.user-guide-mask-menu {
  position: absolute;
    top: 75px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 2100;
    background: rgba(0, 0, 0, 0.4);
}

.user-guide-content {
  font-family: PingFang SC;
  font-style: normal;
  padding: 12px 16px;
  background: #4994FC;
  box-sizing: border-box;
  border-radius: 4px;
  width: 402px;
  font-size: 12px;
  color: #fff;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.24);
  position: relative;
  position: absolute;
  z-index: 2200;
  .user-guide-point {
    width: 40px;
    position: absolute;
    left: -40px;
    top: 48%;
    .user-guider-line {
      width: 100%;
      height: 2px;
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        margin-top: -4px;
      }
    }
  }
   .user-guide-point-vertical {
    width: 40px;
    position: absolute;
    left: 50%;
    top: -130px;

    .user-guider-line-vertical {
      width: 2px;
      height: 130px;
      
      background: #4994FC;
      &::before { // 小圆点在这里
        content: '';
        border: 1px solid #4994FC;
        background-color: #4994FC;
        display: inline-block; // 此句为css样式展示重点🏁
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 0;
        margin-top: -4px;
        left: -3px;
      }
    }
  }
}
.knowBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  margin-right: 13px;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}
.completeBtn {
  border: 1px solid #FFFFFF;
  border-radius: 2px;
  background: #FFFFFF;
  color: #4994FC;
  width: 80px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
  &:focus {
    opacity: 0.8;
  }
}

.btn-next{
  width: 68px;
  height: 26px;
  line-height: 26px;
  background: #FFFFFF;
  border-radius: 2px;
  margin-right: 13px;
  color: #4994FC;
  border-radius: 2px;
  font-size: 12px;
  text-align: center;
}

.btnList{
  display: flex;
  flex-direction: row;
  align-items: center;
}

</style>